import React from 'react';

/*
 * One title, one subtitle, one place for page-level actions. Several pages
 * had grown 2-3 stacked headers (the Layout top bar, a page H1, and a
 * redundant card repeating the same copy) because there was no shared
 * pattern to reach for. Use this instead of a bespoke header block.
 */

interface PageHeaderProps {
  title: string;
  subtitle?: React.ReactNode;
  actions?: React.ReactNode;
}

const PageHeader: React.FC<PageHeaderProps> = ({ title, subtitle, actions }) => (
  <div className="mb-6 flex flex-wrap items-start justify-between gap-4">
    <div>
      <h1 className="text-2xl font-semibold text-gray-900 dark:text-gray-100">{title}</h1>
      {subtitle && <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">{subtitle}</p>}
    </div>
    {actions && <div className="flex shrink-0 items-center gap-2">{actions}</div>}
  </div>
);

export default PageHeader;
